import { cn } from "@weblinkpong/ui";
import type { HTMLAttributes } from "react";

type MainProps = HTMLAttributes<HTMLElement> & Readonly<{ fluid?: boolean }>;

export function Main({ className, fluid = false, ...props }: MainProps) {
  return (
    <main
      data-layout="auto"
      className={cn(
        "px-4 py-6",
        !fluid && "@7xl/content:mx-auto @7xl/content:w-full @7xl/content:max-w-7xl",
        className,
      )}
      {...props}
    />
  );
}
